import { isRegistryEvTariffValue } from './registryFuelTariffOptions';

/** localStorage key for saved vehicle policy presets in the configurator. */
export const VEHICLE_POLICY_STORAGE_KEY = 'vehicleConfiguratorVehiclePolicies';

export const FUEL_TYPE_FIELD_KEY = 'Fuel Type';
export const MICRO_REFILL_FIELD_KEY = 'Micro-refill (L)';
export const OFFLINE_GAP_CAP_FIELD_KEY = 'Offline gap cap (min)';
export const DRAIN_WINDOW_FIELD_KEY = 'Drain window (min)';
export const MAX_BURN_RATE_FIELD_KEY = 'Max burn rate (L/hr)';

/**
 * Vehicle types are no longer hardcoded here — they are admin-managed reference data served by
 * `GET /v3/vehicleTypes`. See `useVehicleTypeOptions` for the fetch and `vehicleTypeOptions.js`
 * for the option shape and the offline fallback list.
 */

export const VEHICLE_POLICY_FIELDS = [
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: FUEL_TYPE_FIELD_KEY,
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Maximum Tank Capacity',
        // description: 'maxTankVolumeL',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Minimum Refill Detection',
        // description: 'refillThresholdL',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Theft/Drain Detection Alert',
        // description: 'drainThresholdL',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Sensor Noise/Spike Filter (L)',
        // description: 'spikeFilterVolumeL',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Fuel Stabilization Wait Time (Sec)',
        // description: 'stableDurationSec',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: 'Allowed Stabilization Fluctuation (L)',
        // description: 'stableToleranceL',
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: MICRO_REFILL_FIELD_KEY,
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: OFFLINE_GAP_CAP_FIELD_KEY,
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: DRAIN_WINDOW_FIELD_KEY,
    },
    {
        groupCategory: 'Fuel Tank Setup',
        fieldKey: MAX_BURN_RATE_FIELD_KEY,
    },
    {
        groupCategory: 'Energy Efficiency (Opportunity Cost)',
        fieldKey: 'Optimal Max Refill Limit (%)',
        // description: 'optimalMaxRefillPct',
    },
    {
        groupCategory: 'Energy Efficiency (Opportunity Cost)',
        fieldKey: 'Optimal Max EV Charge Limit (%)',
        // description: 'optimalMaxChargePct',
    },
    {
        groupCategory: 'Motion & Idling Logic',
        fieldKey: 'Excessive Idling/Standby Timeout (Sec)',
        // description: 'excessiveIdleLimitSec',
    },
    {
        groupCategory: 'Motion & Idling Logic',
        fieldKey: 'Minimum Speed to Register Movement (km/h)',
        // description: 'movingSpeedThresholdKmh',
    },
    {
        groupCategory: 'Motion & Idling Logic',
        fieldKey: 'Enable Excusable Idling',
        // description: 'excusableIdlingEnabled',
    },
    {
        groupCategory: 'Motion & Idling Logic',
        fieldKey: 'Max Excusable Idle Duration (Sec)',
        // description: 'excusableIdlingMaxSec',
    },
    {
        groupCategory: 'Accelerometer & Vibration Calibration',
        fieldKey: 'X-Axis Vibration Sensitivity (G)',
        // description: 'thresholdX',
    },
    {
        groupCategory: 'Accelerometer & Vibration Calibration',
        fieldKey: 'Y-Axis Vibration Sensitivity (G)',
        // description: 'thresholdY',
    },
    {
        groupCategory: 'Accelerometer & Vibration Calibration',
        fieldKey: 'Z-Axis Vibration Sensitivity (G)',
        // description: 'thresholdZ',
    },
    {
        groupCategory: 'Accelerometer & Vibration Calibration',
        fieldKey: 'High Impact / Crash Sensitivity (G)',
        // description: 'highGForceThreshold',
    },
    {
        groupCategory: 'Security & Remote Immobilization',
        fieldKey: 'Enable Remote Immobilizer Interface',
        // description: 'immobilizerEnabled',
    },
    {
        groupCategory: 'Security & Remote Immobilization',
        fieldKey: 'Target Relay Output (Wired DOUT)',
        // description: 'immobilizerDoutIndex',
    },
    {
        groupCategory: 'Security & Remote Immobilization',
        fieldKey: 'Required Safe State to Cut Engine',
        // description: 'immobilizerReqState',
    },
    {
        groupCategory: 'Security & Remote Immobilization',
        fieldKey: 'Safe State Hold Duration (Sec)',
        // description: 'immobilizerReqDurationSec',
    },
    {
        groupCategory: 'Crash & Braking Verification',
        fieldKey: 'Braking Data Source',
        // description: 'brakeDataSource',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Enable Virtual Fuel Fallback',
        // description: 'enabled / disabled',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Force Virtual Fuel (Ignore Hardware Sensors)',
        // description: 'forceVirtual',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Idling Burn Rate (L/hr)',
        // description: 'idleLhr',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'City Consumption Rate (L/100km)',
        // description: 'cityL100km',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Max City Speed Zone (km/h)',
        // description: 'citySpeedKmh',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Average Consumption Rate (L/100km)',
        // description: 'avgL100km',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Max Average Speed Zone (km/h)',
        // description: 'avgSpeedKmh',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Highway Consumption Rate (L/100km)',
        // description: 'hwyL100km',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Highway Speed Zone Start (km/h)',
        // description: 'hwySpeedKmh',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Overspeeding Wind Resistance Penalty (%)',
        // description: 'penaltyPct',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Overspeeding Penalty Interval (km/h)',
        // description: 'penaltyIntervalKmh',
    },
    {
        groupCategory: 'GNSS Virtual Fuel (Mathematical Fallback)',
        fieldKey: 'Receipt Calibration Multiplier',
        // description: 'correction',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Battery System Architecture',
        // description: 'batterySystem',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Weak Battery Cranking Alert (Volts)',
        // description: 'crankWarningV',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Cranking Battery Failure Limit (Volts)',
        // description: 'crankFailV',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Alternator Charging Minimum (Volts)',
        // description: 'altThresholdV',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Alternator Failure Wait Time (Sec)',
        // description: 'altSettleSec',
    },
    {
        groupCategory: 'Battery Diagnostic',
        fieldKey: 'Max Parked Parasitic Drain (V/hr)',
        // description: 'parasiticDrawVhr',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Engine Redline Limit (RPM)',
        // description: 'maxRpm',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Over-Revving Warning Delay (Sec)',
        // description: 'overRevDurationSec',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Aggressive Throttle Limit (%)',
        // description: 'highThrottlePct',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Aggressive Throttle Delay (Sec)',
        // description: 'highThrottleDurationSec',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'High Engine Load / Strain Limit (%)',
        // description: 'highLoadPct',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'High Engine Load Warning Delay (Sec)',
        // description: 'highLoadDurationSec',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Max Safe Coolant Temperature (°C)',
        // description: 'maxCoolantTempC',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Overheating Critical Alarm Delay (Sec)',
        // description: 'overheatDurationSec',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Cold Engine Threshold (°C)',
        // description: 'coldEngineTempC',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Max Safe RPM for Cold Engine',
        // description: 'coldEngineMaxRpm',
    },
    {
        groupCategory: 'ICE Health & Mechanical Diagnostics',
        fieldKey: 'Cold Engine Abuse Delay (Min)',
        // description: 'coldAbuseDurationMin',
    },
    {
        groupCategory: 'EV High-Voltage Health',
        fieldKey: 'Max Safe HV Battery Temperature (°C)',
        // description: 'maxEvTempC',
    },
    {
        groupCategory: 'EV High-Voltage Health',
        fieldKey: 'Battery Thermal Runaway Delay (Min)',
        // description: 'evOverheatDurationMin',
    },
    {
        groupCategory: 'Trip Boundaries (Software Fallbacks)',
        fieldKey: 'Software Trip Start Speed (km/h)',
        // description: 'tripStartSpeedKmh',
    },
    {
        groupCategory: 'Trip Boundaries (Software Fallbacks)',
        fieldKey: 'Minimum Distance to Force Trip Start (km)',
        // description: 'tripStartDistThresholdKm',
    },
    {
        groupCategory: 'Trip Boundaries (Software Fallbacks)',
        fieldKey: 'Ignition OFF Trip End Timeout (Sec)',
        // description: 'tripIgnOffTimeoutSec',
    },
    {
        groupCategory: 'Trip Boundaries (Software Fallbacks)',
        fieldKey: 'Minimum Total Distance for Valid Trip (km)',
        // description: 'tripMinDistanceKm',
    },
];

export const GNSS_FALLBACK_FIELD_KEY = 'Enable Virtual Fuel Fallback';
export const FORCE_VIRTUAL_FUEL_FIELD_KEY = 'Force Virtual Fuel (Ignore Hardware Sensors)';
/** Must match `fieldKey` in VEHICLE_POLICY_FIELDS so form state and dropdown wiring stay aligned. */
export const BRAKE_DATA_SOURCE_FIELD_KEY = 'Braking Data Source';
export const IMMOBILIZER_ENABLED_FIELD_KEY = 'Enable Remote Immobilizer Interface';
export const IMMOBILIZER_REQ_STATE_FIELD_KEY = 'Required Safe State to Cut Engine';
export const EXCUSABLE_IDLING_ENABLED_FIELD_KEY = 'Enable Excusable Idling';

/** Brake / crash sensor source (stored string on vehicle preset). */
export const BRAKE_DATA_SOURCE_OPTIONS = [
    { value: 'can', label: 'CAN Bus' },
    { value: 'din1', label: 'Digital Input 1' },
    { value: 'din2', label: 'Digital Input 2' },
    { value: 'harsh', label: 'Harsh Braking' },
];

/** Motion status codes for immobilizer required state (label in UI, numeric value persisted). */
export const IMMOBILIZER_REQ_STATE_OPTIONS = [
    { value: 100, label: 'Stop' },
    { value: 150, label: 'Movement Detected' },
    { value: 200, label: 'Moving' },
    { value: 300, label: 'Towing' },
    { value: 400, label: 'Normal Idle' },
    { value: 450, label: 'Excessive Idle' },
    { value: 460, label: 'Excusable Idle' },
    { value: 700, label: 'Crash Event' },
    { value: 800, label: 'EV Standby' },
    { value: 850, label: 'Hybrid Standby' },
];

export const ENABLE_OPTION = 'enable';
export const DISABLE_OPTION = 'disable';

/** Same values as enable/disable; labels read as True/False for boolean policy fields. */
export const TRUE_FALSE_SELECT_OPTIONS = [
    { value: ENABLE_OPTION, label: 'True' },
    { value: DISABLE_OPTION, label: 'False' },
];

export const ENABLE_DISABLE_OPTIONS = [
    { value: ENABLE_OPTION, label: 'Enable' },
    { value: DISABLE_OPTION, label: 'Disable' },
];

export const isFuelTypePolicyField = (fieldKey) => fieldKey === FUEL_TYPE_FIELD_KEY;

const isValidFuelType = (value, validValues = null) => {
    const trimmed = String(value || '').trim();
    if (!trimmed) return false;
    if (validValues instanceof Set) return validValues.has(trimmed);
    if (Array.isArray(validValues)) return validValues.includes(trimmed);
    return true;
};

export const isEnableDisablePolicyField = (fieldKey) => (
    fieldKey === GNSS_FALLBACK_FIELD_KEY
    || fieldKey === FORCE_VIRTUAL_FUEL_FIELD_KEY
    || fieldKey === IMMOBILIZER_ENABLED_FIELD_KEY
    || fieldKey === EXCUSABLE_IDLING_ENABLED_FIELD_KEY
);

export const isImmobilizerReqStatePolicyField = (fieldKey) => (
    fieldKey === IMMOBILIZER_REQ_STATE_FIELD_KEY
);

export const isBrakeDataSourcePolicyField = (fieldKey) => (
    fieldKey === BRAKE_DATA_SOURCE_FIELD_KEY
);

/** Config for standard (string-equality) dropdown fields, used to drive renderPolicyFieldInput. */
export const STANDARD_DROPDOWN_CONFIGS = [
    { predicate: isBrakeDataSourcePolicyField, placeholder: 'Brake data source', options: BRAKE_DATA_SOURCE_OPTIONS },
    { predicate: isEnableDisablePolicyField, placeholder: 'Select enable / disable', options: ENABLE_DISABLE_OPTIONS },
];

export const createEmptyVehiclePolicyValues = () => (
    VEHICLE_POLICY_FIELDS.reduce((accumulator, current) => {
        accumulator[current.fieldKey] = '';
        return accumulator;
    }, {})
);

const normalizeBrakeDataSourceForPayload = (rawValue) => {
    const raw = String(rawValue || '').trim().toLowerCase();
    const allowed = BRAKE_DATA_SOURCE_OPTIONS.map((o) => o.value);
    return allowed.includes(raw) ? raw : '';
};

/** Map API / persisted values to option `value` strings (see BRAKE_DATA_SOURCE_OPTIONS). */
const normalizeBrakeDataSourceFromPreset = (rawValue) => {
    const allowed = BRAKE_DATA_SOURCE_OPTIONS.map((o) => o.value);
    const brakeStr = rawValue != null && rawValue !== '' ? String(rawValue).trim().toLowerCase() : '';
    if (brakeStr && allowed.includes(brakeStr)) {
        return brakeStr;
    }
    const labelAliases = {
        'can bus': 'can',
        can_bus: 'can',
        'digital input 1': 'din1',
        digital_input_1: 'din1',
        digitalinput1: 'din1',
        di1: 'din1',
        'di 1': 'din1',
        'digital input 2': 'din2',
        digital_input_2: 'din2',
        digitalinput2: 'din2',
        di2: 'din2',
        'di 2': 'din2',
        'harsh braking': 'harsh',
        'software harsh braking': 'harsh',
    };
    const mapped = brakeStr ? labelAliases[brakeStr] : '';
    return mapped && allowed.includes(mapped) ? mapped : '';
};

export const extractVehiclePresetListFromResult = (result) => {
    const payload = result?.data;

    if (Array.isArray(payload)) {
        return payload;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    if (Array.isArray(payload?.vehicleAdminPresets)) {
        return payload.vehicleAdminPresets;
    }

    if (Array.isArray(payload?.presets)) {
        return payload.presets;
    }

    if (Array.isArray(payload?.rows)) {
        return payload.rows;
    }

    return [];
};

export const normalizePolicyOptionId = (id) => String(id ?? '').trim();

/** Mirrors backend VEHICLE_PRESET_CLIENT_KEYS — only these top-level keys are persisted. */
export const VEHICLE_PRESET_CLIENT_KEYS = [
    'presetName',
    'vehicleType',
    'description',
    'fuelSetup',
    'fuelTypeTariff',
    'hardwarePolicy',
    'motionInference',
    'accelerometer',
    'energyEfficiency',
    'crashBraking',
    'brakeDataSource',
    'securityRemote',
    'immobilization',
    'gnssVirtualFuel',
    'batteryDiagnostic',
    'iceHealth',
    'evHealth',
    'tripBoundary',
];

export const coercePolicyOid = (value) => {
    if (value == null || value === '') return '';
    if (typeof value === 'string' || typeof value === 'number') {
        return normalizePolicyOptionId(value);
    }
    if (typeof value === 'object') {
        return normalizePolicyOptionId(
            value.oid || value.id || value._id || value.value,
        );
    }
    return '';
};

const parsePresetNumber = (value) => {
    if (value === '' || value == null || value === undefined) {
        return undefined;
    }
    const numeric = Number(value);
    return Number.isFinite(numeric) ? numeric : undefined;
};

export const validateVehicleFuelLedgerFieldValues = (fieldValues = {}) => {
    const errors = [];
    const hasValue = (fieldKey) => fieldValues[fieldKey] !== ''
        && fieldValues[fieldKey] != null;
    const tankCapacity = parsePresetNumber(fieldValues['Maximum Tank Capacity']);
    const refillThreshold = parsePresetNumber(fieldValues['Minimum Refill Detection']);
    const theftThreshold = parsePresetNumber(fieldValues['Theft/Drain Detection Alert']);
    const spikeFilter = parsePresetNumber(fieldValues['Sensor Noise/Spike Filter (L)']);
    const sloshDuration = parsePresetNumber(fieldValues['Fuel Stabilization Wait Time (Sec)']);
    const sloshTolerance = parsePresetNumber(fieldValues['Allowed Stabilization Fluctuation (L)']);
    const microRefill = parsePresetNumber(fieldValues[MICRO_REFILL_FIELD_KEY]);

    [
        ['Maximum Tank Capacity', tankCapacity, 'Tank capacity'],
        ['Minimum Refill Detection', refillThreshold, 'Minimum refill detection'],
        ['Theft/Drain Detection Alert', theftThreshold, 'Theft/drain detection alert'],
        ['Sensor Noise/Spike Filter (L)', spikeFilter, 'Spike filter volume'],
        ['Fuel Stabilization Wait Time (Sec)', sloshDuration, 'Slosh duration'],
        ['Allowed Stabilization Fluctuation (L)', sloshTolerance, 'Slosh tolerance'],
    ].forEach(([fieldKey, value, label]) => {
        if (hasValue(fieldKey) && value === undefined) {
            errors.push(`${label} must be a valid number.`);
        }
    });

    const validTankCapacity = tankCapacity !== undefined
        && tankCapacity >= 5
        && tankCapacity <= 2000;
    if (tankCapacity !== undefined && !validTankCapacity) {
        errors.push('Tank capacity must be between 5 and 2000 L.');
    }
    if (spikeFilter !== undefined && (spikeFilter < 1 || spikeFilter > 50)) {
        errors.push('Spike filter volume must be between 1 and 50 L.');
    }
    if (sloshTolerance !== undefined && sloshTolerance < 0.1) {
        errors.push('Slosh tolerance must be at least 0.1 L.');
    }
    if (validTankCapacity) {
        const quarterTank = tankCapacity / 4;
        if (refillThreshold !== undefined
            && (refillThreshold < 1 || refillThreshold > quarterTank)) {
            errors.push(`Minimum refill detection must be between 1 and ${quarterTank.toFixed(2)} L (tank/4).`);
        }
        if (theftThreshold !== undefined
            && (theftThreshold < 1 || theftThreshold > quarterTank)) {
            errors.push(`Theft/drain detection alert must be between 1 and ${quarterTank.toFixed(2)} L (tank/4).`);
        }
    }
    if (refillThreshold !== undefined && spikeFilter !== undefined
        && refillThreshold < spikeFilter) {
        errors.push('Minimum refill detection must be greater than or equal to spike filter volume.');
    }
    if (sloshDuration !== undefined && sloshDuration <= 0) {
        errors.push('Slosh duration must be greater than 0 seconds.');
    }
    if (microRefill !== undefined) {
        if (microRefill <= 0) {
            errors.push('Micro-refill must be greater than 0 L or left blank to disable.');
        } else if (refillThreshold !== undefined && microRefill >= refillThreshold) {
            errors.push('Micro-refill must be less than the refill threshold.');
        }
    }

    [
        [OFFLINE_GAP_CAP_FIELD_KEY, 'Offline gap cap'],
        [DRAIN_WINDOW_FIELD_KEY, 'Drain window'],
        [MAX_BURN_RATE_FIELD_KEY, 'Max burn rate'],
    ].forEach(([fieldKey, label]) => {
        const value = parsePresetNumber(fieldValues[fieldKey]);
        if (value !== undefined && value <= 0) {
            errors.push(`${label} must be greater than 0.`);
        }
    });

    return { valid: errors.length === 0, errors };
};

const compactSection = (section) => {
    if (!section || typeof section !== 'object') return {};
    return Object.entries(section).reduce((accumulator, [key, val]) => {
        if (val !== undefined && val !== null && val !== '') {
            accumulator[key] = val;
        }
        return accumulator;
    }, {});
};

const pickVehiclePresetClientKeys = (snapshot) => (
    VEHICLE_PRESET_CLIENT_KEYS.reduce((accumulator, key) => {
        if (snapshot[key] !== undefined) {
            accumulator[key] = snapshot[key];
        }
        return accumulator;
    }, {})
);

export const resolveBatteryPolicyIdFromPreset = (preset = {}) => {
    const raw = preset?.hardwarePolicy?.batteryPolicyOid
        ?? preset?.hardwarePolicy?.batteryPolicyId
        ?? preset?.batteryDiagnostic?.batteryPolicyOid
        ?? preset?.batteryDiagnostic?.batteryPolicyId
        ?? preset?.hardwarePolicyBindings?.batteryPolicyOid
        ?? preset?.hardwarePolicyBindings?.batteryPolicyId
        ?? preset?.hardwarePolicyBindings?.batteryPolicy
        ?? preset?.batteryPolicyId
        ?? preset?.batteryPolicyOid
        ?? preset?.batteryPolicy?.oid
        ?? preset?.batteryPolicy;
    return coercePolicyOid(raw);
};

export const resolveFuelPolicyIdFromPreset = (preset = {}) => {
    const raw = preset?.hardwarePolicy?.fuelPolicyOid
        ?? preset?.hardwarePolicy?.fuelPolicyId
        ?? preset?.fuelSetup?.fuelPolicyOid
        ?? preset?.fuelSetup?.fuelPolicyId
        ?? preset?.hardwarePolicyBindings?.fuelPolicyOid
        ?? preset?.hardwarePolicyBindings?.fuelPolicyId
        ?? preset?.hardwarePolicyBindings?.fuelPolicy
        ?? preset?.fuelPolicyId
        ?? preset?.fuelPolicyOid
        ?? preset?.fuelPolicy?.oid
        ?? preset?.fuelPolicy;
    return coercePolicyOid(raw);
};

export const mapPolicyListToDropdownOptions = (list = []) => (
    list.map((item) => ({
        value: normalizePolicyOptionId(item.oid || item.id || item._id),
        label: item.name || '',
    })).filter((option) => option.value && option.label)
);

export const findPolicyOptionById = (options, policyId) => {
    const normalizedId = normalizePolicyOptionId(policyId);
    if (!normalizedId) return null;
    return options.find((option) => normalizePolicyOptionId(option.value) === normalizedId) || null;
};

export const createVehiclePresetPayload = (
    presetName,
    vehicleType,
    descriptionValue,
    fieldValues,
    presetId = null,
    hardwareBindings = {},
    registryContext = {},
) => {
    const { validFuelTariffValues = null, activePriceId = null } = registryContext;
    const fuelPolicyOid = coercePolicyOid(hardwareBindings.fuelPolicyId) || null;
    const batteryPolicyOid = coercePolicyOid(hardwareBindings.batteryPolicyId) || null;

    const brakeDataSource = normalizeBrakeDataSourceForPayload(
        fieldValues[BRAKE_DATA_SOURCE_FIELD_KEY],
    );
    const immobilizerReqState = parsePresetNumber(fieldValues[IMMOBILIZER_REQ_STATE_FIELD_KEY]);
    const excusableIdlingEnabled = fieldValues[EXCUSABLE_IDLING_ENABLED_FIELD_KEY] === ENABLE_OPTION;

    const selectedFuelOrTariff = isValidFuelType(fieldValues[FUEL_TYPE_FIELD_KEY], validFuelTariffValues)
        ? String(fieldValues[FUEL_TYPE_FIELD_KEY]).trim()
        : '';
    const fuelType = selectedFuelOrTariff && !isRegistryEvTariffValue(selectedFuelOrTariff)
        ? selectedFuelOrTariff
        : undefined;
    const chargingTariff = selectedFuelOrTariff && isRegistryEvTariffValue(selectedFuelOrTariff)
        ? selectedFuelOrTariff
        : undefined;

    const fuelSetup = compactSection({
        maxTankVolumeL: parsePresetNumber(fieldValues['Maximum Tank Capacity']),
        refillThresholdL: parsePresetNumber(fieldValues['Minimum Refill Detection']),
        drainThresholdL: parsePresetNumber(fieldValues['Theft/Drain Detection Alert']),
        spikeFilterVolumeL: parsePresetNumber(fieldValues['Sensor Noise/Spike Filter (L)']),
        stableDurationSec: parsePresetNumber(fieldValues['Fuel Stabilization Wait Time (Sec)']),
        stableToleranceL: parsePresetNumber(fieldValues['Allowed Stabilization Fluctuation (L)']),
        microRefillL: (() => {
            const value = parsePresetNumber(fieldValues[MICRO_REFILL_FIELD_KEY]);
            return value !== undefined && value > 0 ? value : 0;
        })(),
        gapCapMin: parsePresetNumber(fieldValues[OFFLINE_GAP_CAP_FIELD_KEY]),
        drainSpanMin: parsePresetNumber(fieldValues[DRAIN_WINDOW_FIELD_KEY]),
        maxBurnRateLh: parsePresetNumber(fieldValues[MAX_BURN_RATE_FIELD_KEY]),
    });

    // Fuel type + active price live in their own section to match the backend contract.
    // activePrice is an optional registry record id; when omitted the backend resolves
    // the live price from the Fuel & Energy Price Registry by fuel type.
    const fuelTypeTariff = compactSection({
        fuelType,
        chargingTariff,
        activePrice: coercePolicyOid(activePriceId) || undefined,
    });

    // Hardware policy bindings (fuel + battery) are persisted as their own section.
    const hardwarePolicy = compactSection({
        fuelPolicyOid,
        fuelPolicyId: fuelPolicyOid,
        batteryPolicyOid,
        batteryPolicyId: batteryPolicyOid,
    });

    const batteryDiagnostic = compactSection({
        batterySystem: (fieldValues['Battery System Architecture'] || '').trim() || undefined,
        crankWarningV: parsePresetNumber(fieldValues['Weak Battery Cranking Alert (Volts)']),
        crankFailV: parsePresetNumber(fieldValues['Cranking Battery Failure Limit (Volts)']),
        altThresholdV: parsePresetNumber(fieldValues['Alternator Charging Minimum (Volts)']),
        altSettleSec: parsePresetNumber(fieldValues['Alternator Failure Wait Time (Sec)']),
        parasiticDrawVhr: parsePresetNumber(fieldValues['Max Parked Parasitic Drain (V/hr)']),
    });

    const securityRemote = compactSection({
        immobilizerEnabled: fieldValues[IMMOBILIZER_ENABLED_FIELD_KEY] === ENABLE_OPTION ? 1 : 0,
        immobilizerDoutIndex: parsePresetNumber(fieldValues['Target Relay Output (Wired DOUT)']),
        immobilizerReqState,
        immobilizerReqDurationSec: parsePresetNumber(fieldValues['Safe State Hold Duration (Sec)']),
    });

    const immobilization = immobilizerReqState !== undefined
        ? { immobilizerReqState }
        : {};

    const snapshot = pickVehiclePresetClientKeys({
        presetName: (presetName || '').trim(),
        vehicleType: (vehicleType || '').trim(),
        description: descriptionValue || '',
        fuelSetup,
        fuelTypeTariff,
        hardwarePolicy,
        motionInference: compactSection({
            excessiveIdleLimitSec: parsePresetNumber(fieldValues['Excessive Idling/Standby Timeout (Sec)']),
            movingSpeedThresholdKmh: parsePresetNumber(fieldValues['Minimum Speed to Register Movement (km/h)']),
            excusableIdlingEnabled,
            excusableIdlingMaxSec: parsePresetNumber(fieldValues['Max Excusable Idle Duration (Sec)']),
        }),
        accelerometer: compactSection({
            thresholdX: parsePresetNumber(fieldValues['X-Axis Vibration Sensitivity (G)']),
            thresholdY: parsePresetNumber(fieldValues['Y-Axis Vibration Sensitivity (G)']),
            thresholdZ: parsePresetNumber(fieldValues['Z-Axis Vibration Sensitivity (G)']),
            highGForceThreshold: parsePresetNumber(fieldValues['High Impact / Crash Sensitivity (G)']),
        }),
        energyEfficiency: compactSection({
            optimalMaxRefillPct: parsePresetNumber(fieldValues['Optimal Max Refill Limit (%)']),
            optimalMaxChargePct: parsePresetNumber(fieldValues['Optimal Max EV Charge Limit (%)']),
        }),
        crashBraking: brakeDataSource ? { brakeDataSource } : {},
        brakeDataSource: brakeDataSource || undefined,
        securityRemote,
        immobilization,
        gnssVirtualFuel: compactSection({
            toggleGnssEnable: fieldValues[GNSS_FALLBACK_FIELD_KEY] === ENABLE_OPTION,
            forceVirtual: fieldValues[FORCE_VIRTUAL_FUEL_FIELD_KEY] === ENABLE_OPTION,
            idleLhr: parsePresetNumber(fieldValues['Idling Burn Rate (L/hr)']),
            cityL100km: parsePresetNumber(fieldValues['City Consumption Rate (L/100km)']),
            citySpeedKmh: parsePresetNumber(fieldValues['Max City Speed Zone (km/h)']),
            avgL100km: parsePresetNumber(fieldValues['Average Consumption Rate (L/100km)']),
            avgSpeedKmh: parsePresetNumber(fieldValues['Max Average Speed Zone (km/h)']),
            hwyL100km: parsePresetNumber(fieldValues['Highway Consumption Rate (L/100km)']),
            hwySpeedKmh: parsePresetNumber(fieldValues['Highway Speed Zone Start (km/h)']),
            penaltyPct: parsePresetNumber(fieldValues['Overspeeding Wind Resistance Penalty (%)']),
            penaltyIntervalKmh: parsePresetNumber(fieldValues['Overspeeding Penalty Interval (km/h)']),
            correction: parsePresetNumber(fieldValues['Receipt Calibration Multiplier']),
        }),
        batteryDiagnostic,
        iceHealth: compactSection({
            maxRpm: parsePresetNumber(fieldValues['Engine Redline Limit (RPM)']),
            overRevDurationSec: parsePresetNumber(fieldValues['Over-Revving Warning Delay (Sec)']),
            highThrottlePct: parsePresetNumber(fieldValues['Aggressive Throttle Limit (%)']),
            highThrottleDurationSec: parsePresetNumber(fieldValues['Aggressive Throttle Delay (Sec)']),
            highLoadPct: parsePresetNumber(fieldValues['High Engine Load / Strain Limit (%)']),
            highLoadDurationSec: parsePresetNumber(fieldValues['High Engine Load Warning Delay (Sec)']),
            maxCoolantTempC: parsePresetNumber(fieldValues['Max Safe Coolant Temperature (°C)']),
            overheatDurationSec: parsePresetNumber(fieldValues['Overheating Critical Alarm Delay (Sec)']),
            coldEngineTempC: parsePresetNumber(fieldValues['Cold Engine Threshold (°C)']),
            coldEngineMaxRpm: parsePresetNumber(fieldValues['Max Safe RPM for Cold Engine']),
            coldAbuseDurationMin: parsePresetNumber(fieldValues['Cold Engine Abuse Delay (Min)']),
        }),
        evHealth: compactSection({
            maxEvTempC: parsePresetNumber(fieldValues['Max Safe HV Battery Temperature (°C)']),
            evOverheatDurationMin: parsePresetNumber(fieldValues['Battery Thermal Runaway Delay (Min)']),
        }),
        tripBoundary: compactSection({
            tripStartSpeedKmh: parsePresetNumber(fieldValues['Software Trip Start Speed (km/h)']),
            tripIgnOffTimeoutSec: parsePresetNumber(fieldValues['Ignition OFF Trip End Timeout (Sec)']),
            tripStartDistThresholdKm: parsePresetNumber(fieldValues['Minimum Distance to Force Trip Start (km)']),
            tripMinDistanceKm: parsePresetNumber(fieldValues['Minimum Total Distance for Valid Trip (km)']),
        }),
    });

    const vehiclePreset = presetId
        ? { oid: presetId, ...snapshot }
        : snapshot;

    return { vehiclePreset };
};

export const mapVehiclePresetToFieldValues = (preset = {}) => {
    let gnssFallbackValue = '';
    if (preset?.gnssVirtualFuel?.toggleGnssEnable === true) {
        gnssFallbackValue = ENABLE_OPTION;
    } else if (preset?.gnssVirtualFuel?.toggleGnssEnable === false) {
        gnssFallbackValue = DISABLE_OPTION;
    }

    let forceVirtualFuelValue = '';
    const rawForceVirtual = preset?.gnssVirtualFuel?.forceVirtual;
    if (rawForceVirtual === true || rawForceVirtual === 1 || rawForceVirtual === '1') {
        forceVirtualFuelValue = ENABLE_OPTION;
    } else if (rawForceVirtual === false || rawForceVirtual === 0 || rawForceVirtual === '0') {
        forceVirtualFuelValue = DISABLE_OPTION;
    }

    const rawImmobilizerEnabled = preset?.securityRemote?.immobilizerEnabled;
    let immobilizerEnabledValue = '';
    if (rawImmobilizerEnabled === true || rawImmobilizerEnabled === 1 || rawImmobilizerEnabled === '1') {
        immobilizerEnabledValue = ENABLE_OPTION;
    } else if (rawImmobilizerEnabled === false || rawImmobilizerEnabled === 0 || rawImmobilizerEnabled === '0') {
        immobilizerEnabledValue = DISABLE_OPTION;
    }

    const rawReqState = preset?.securityRemote?.immobilizerReqState ?? preset?.immobilization?.immobilizerReqState;
    const reqStateNum = Number(rawReqState);
    const immobilizerReqStateValue = rawReqState != null && rawReqState !== '' && !Number.isNaN(reqStateNum)
        ? String(reqStateNum)
        : '';

    const brakeDataSourceRaw = preset?.crashBraking?.brakeDataSource ?? preset?.brakeDataSource;
    const brakeDataSourceValue = normalizeBrakeDataSourceFromPreset(brakeDataSourceRaw);

    const rawExcusableIdlingEnabled = preset?.motionInference?.excusableIdlingEnabled;
    let excusableIdlingEnabledValue = '';
    if (rawExcusableIdlingEnabled === true || rawExcusableIdlingEnabled === 1 || rawExcusableIdlingEnabled === '1') {
        excusableIdlingEnabledValue = ENABLE_OPTION;
    } else if (rawExcusableIdlingEnabled === false || rawExcusableIdlingEnabled === 0 || rawExcusableIdlingEnabled === '0') {
        excusableIdlingEnabledValue = DISABLE_OPTION;
    }

    return {
        ...createEmptyVehiclePolicyValues(),
        [FUEL_TYPE_FIELD_KEY]: (() => {
            const tariff = preset?.fuelTypeTariff?.chargingTariff ?? preset?.fuelTypeTariff?.tariff;
            if (tariff) return String(tariff).trim();
            const fuelType = preset?.fuelTypeTariff?.fuelType ?? preset?.fuelSetup?.fuelType;
            const trimmedFuel = fuelType ? String(fuelType).trim() : '';
            return trimmedFuel;
        })(),
        'Maximum Tank Capacity': preset?.fuelSetup?.maxTankVolumeL ?? '',
        'Minimum Refill Detection': preset?.fuelSetup?.refillThresholdL ?? '',
        'Theft/Drain Detection Alert': preset?.fuelSetup?.drainThresholdL ?? '',
        'Sensor Noise/Spike Filter (L)': preset?.fuelSetup?.spikeFilterVolumeL ?? '',
        'Fuel Stabilization Wait Time (Sec)': preset?.fuelSetup?.stableDurationSec ?? '',
        'Allowed Stabilization Fluctuation (L)': preset?.fuelSetup?.stableToleranceL ?? '',
        [MICRO_REFILL_FIELD_KEY]: Number(preset?.fuelSetup?.microRefillL) > 0
            ? preset.fuelSetup.microRefillL
            : '',
        [OFFLINE_GAP_CAP_FIELD_KEY]: preset?.fuelSetup?.gapCapMin ?? '',
        [DRAIN_WINDOW_FIELD_KEY]: preset?.fuelSetup?.drainSpanMin ?? '',
        [MAX_BURN_RATE_FIELD_KEY]: preset?.fuelSetup?.maxBurnRateLh ?? '',
        'Optimal Max Refill Limit (%)': preset?.energyEfficiency?.optimalMaxRefillPct ?? '',
        'Optimal Max EV Charge Limit (%)': preset?.energyEfficiency?.optimalMaxChargePct ?? '',
        'Excessive Idling/Standby Timeout (Sec)': preset?.motionInference?.excessiveIdleLimitSec ?? '',
        'Minimum Speed to Register Movement (km/h)': preset?.motionInference?.movingSpeedThresholdKmh ?? '',
        [EXCUSABLE_IDLING_ENABLED_FIELD_KEY]: excusableIdlingEnabledValue,
        'Max Excusable Idle Duration (Sec)': preset?.motionInference?.excusableIdlingMaxSec ?? '',
        'X-Axis Vibration Sensitivity (G)': preset?.accelerometer?.thresholdX ?? '',
        'Y-Axis Vibration Sensitivity (G)': preset?.accelerometer?.thresholdY ?? '',
        'Z-Axis Vibration Sensitivity (G)': preset?.accelerometer?.thresholdZ ?? '',
        'High Impact / Crash Sensitivity (G)': preset?.accelerometer?.highGForceThreshold ?? '',
        [IMMOBILIZER_ENABLED_FIELD_KEY]: immobilizerEnabledValue,
        'Target Relay Output (Wired DOUT)': preset?.securityRemote?.immobilizerDoutIndex ?? '',
        [IMMOBILIZER_REQ_STATE_FIELD_KEY]: immobilizerReqStateValue,
        'Safe State Hold Duration (Sec)': preset?.securityRemote?.immobilizerReqDurationSec ?? '',
        [GNSS_FALLBACK_FIELD_KEY]: gnssFallbackValue,
        [FORCE_VIRTUAL_FUEL_FIELD_KEY]: forceVirtualFuelValue,
        [BRAKE_DATA_SOURCE_FIELD_KEY]: brakeDataSourceValue,
        'Idling Burn Rate (L/hr)': preset?.gnssVirtualFuel?.idleLhr ?? '',
        'City Consumption Rate (L/100km)': preset?.gnssVirtualFuel?.cityL100km ?? '',
        'Max City Speed Zone (km/h)': preset?.gnssVirtualFuel?.citySpeedKmh ?? '',
        'Average Consumption Rate (L/100km)': preset?.gnssVirtualFuel?.avgL100km ?? '',
        'Max Average Speed Zone (km/h)': preset?.gnssVirtualFuel?.avgSpeedKmh ?? '',
        'Highway Consumption Rate (L/100km)': preset?.gnssVirtualFuel?.hwyL100km ?? '',
        'Highway Speed Zone Start (km/h)': preset?.gnssVirtualFuel?.hwySpeedKmh ?? '',
        'Overspeeding Wind Resistance Penalty (%)': preset?.gnssVirtualFuel?.penaltyPct ?? '',
        'Overspeeding Penalty Interval (km/h)': preset?.gnssVirtualFuel?.penaltyIntervalKmh ?? '',
        'Receipt Calibration Multiplier': preset?.gnssVirtualFuel?.correction ?? '',
        'Battery System Architecture': preset?.batteryDiagnostic?.batterySystem ?? '',
        'Weak Battery Cranking Alert (Volts)': preset?.batteryDiagnostic?.crankWarningV ?? '',
        'Cranking Battery Failure Limit (Volts)': preset?.batteryDiagnostic?.crankFailV ?? '',
        'Alternator Charging Minimum (Volts)': preset?.batteryDiagnostic?.altThresholdV ?? '',
        'Alternator Failure Wait Time (Sec)': preset?.batteryDiagnostic?.altSettleSec ?? '',
        'Max Parked Parasitic Drain (V/hr)': preset?.batteryDiagnostic?.parasiticDrawVhr ?? '',
        'Engine Redline Limit (RPM)': preset?.iceHealth?.maxRpm ?? '',
        'Over-Revving Warning Delay (Sec)': preset?.iceHealth?.overRevDurationSec ?? '',
        'Aggressive Throttle Limit (%)': preset?.iceHealth?.highThrottlePct ?? '',
        'Aggressive Throttle Delay (Sec)': preset?.iceHealth?.highThrottleDurationSec ?? '',
        'High Engine Load / Strain Limit (%)': preset?.iceHealth?.highLoadPct ?? '',
        'High Engine Load Warning Delay (Sec)': preset?.iceHealth?.highLoadDurationSec ?? '',
        'Max Safe Coolant Temperature (°C)': preset?.iceHealth?.maxCoolantTempC ?? '',
        'Overheating Critical Alarm Delay (Sec)': preset?.iceHealth?.overheatDurationSec ?? '',
        'Cold Engine Threshold (°C)': preset?.iceHealth?.coldEngineTempC ?? '',
        'Max Safe RPM for Cold Engine': preset?.iceHealth?.coldEngineMaxRpm ?? '',
        'Cold Engine Abuse Delay (Min)': preset?.iceHealth?.coldAbuseDurationMin ?? '',
        'Max Safe HV Battery Temperature (°C)': preset?.evHealth?.maxEvTempC ?? '',
        'Battery Thermal Runaway Delay (Min)': preset?.evHealth?.evOverheatDurationMin ?? '',
        'Software Trip Start Speed (km/h)': preset?.tripBoundary?.tripStartSpeedKmh ?? '',
        'Ignition OFF Trip End Timeout (Sec)': preset?.tripBoundary?.tripIgnOffTimeoutSec ?? '',
        'Minimum Distance to Force Trip Start (km)': preset?.tripBoundary?.tripStartDistThresholdKm ?? '',
        'Minimum Total Distance for Valid Trip (km)': preset?.tripBoundary?.tripMinDistanceKm ?? '',
    };
};
